import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import CustomerServiceNavigator from "../../../navigation/CustomerServiceNavigator";
import styles from "./customerService.module.css";

const CustomerService = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("customer-support", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/customer-support/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <CustomerServiceNavigator />
    </div>
  );
};

export default CustomerService;
